(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) { module.exports = factory; return; }
  if (root.CentralSportExpressDeliveryProductBenefit) return;
  root.CentralSportExpressDeliveryProductBenefit = factory(root);
})(typeof window !== 'undefined' ? window : globalThis, function createBenefit(runtime) {
  'use strict';
  var EVENT = 'cs:express-delivery:updated';
  function presentation(engine) {
    if (!engine || typeof engine.resolveDelivery !== 'function') return { visible: true, status: 'fallback', template: 'fallback' };
    try {
      var result = engine.resolveDelivery({ product: { eligible: true, available: true } });
      if (result.visible === false) return { visible: false, status: result.status || result.state || 'unavailable', template: null };
      if (result.status === 'today') return { visible: true, status: 'today', template: 'today' };
      if (result.status === 'next_business_day') return { visible: true, status: 'next_business_day', template: 'next_business_day' };
      if (result.status === 'weekend') return { visible: true, status: 'weekend', template: 'weekend' };
      if (result.status === 'holiday') return { visible: true, status: 'holiday', template: 'holiday' };
      if (result.status === 'blackout') return { visible: true, status: 'blackout', template: 'blackout' };
      return { visible: true, status: 'fallback', template: 'fallback' };
    } catch (error) { return { visible: true, status: 'error', template: 'error' }; }
  }
  function setVisibility(element, visible) {
    element.hidden = !visible;
    if (element.style && typeof element.style.setProperty === 'function') {
      if (!visible) element.style.setProperty('display', 'none');
      else element.style.removeProperty('display');
    }
  }
  function templateContent(element, name) {
    var template = element.querySelector('[data-cs-express-benefit-template="' + name + '"]');
    return template && template.content ? template.content.cloneNode(true) : null;
  }
  function hasVisibleContent(content) {
    return Boolean(content && String(content.textContent || '').replace(/\u00a0/g, ' ').trim());
  }
  function renderTemplate(element, name, status) {
    var container = element.querySelector('[data-cs-express-benefit-content]');
    var content = templateContent(element, name);
    var visible = Boolean(container && hasVisibleContent(content));
    if (container && content) container.replaceChildren(content);
    else if (container) container.replaceChildren();
    setVisibility(element, visible);
    element.dataset.csStatus = status;
  }
  function updateNonExpress(element) {
    renderTemplate(element, 'not_eligible', 'not_eligible');
  }
  function update(element) {
    var result = presentation(runtime && runtime.CentralSportExpressDelivery);
    if (result.visible === false) {
      setVisibility(element, false);
      element.dataset.csStatus = result.status;
      return;
    }
    renderTemplate(element, result.template, result.status);
  }
  function register() {
    if (!runtime || !runtime.customElements || !runtime.HTMLElement || runtime.customElements.get('cs-express-delivery-product-benefit')) return;
    class Benefit extends runtime.HTMLElement {
      constructor() { super(); this.csUpdate = () => update(this); }
      connectedCallback() {
        if (this.dataset && this.dataset.csExpressEligible === 'false') {
          updateNonExpress(this);
          return;
        }
        if (this.csListening) return;
        this.csListening = true;
        runtime.document.addEventListener(EVENT, this.csUpdate);
        update(this);
      }
      disconnectedCallback() { if (!this.csListening) return; runtime.document.removeEventListener(EVENT, this.csUpdate); this.csListening = false; }
    }
    runtime.customElements.define('cs-express-delivery-product-benefit', Benefit);
  }
  register();
  return Object.freeze({
    namespace: 'cs-express-delivery-product-benefit',
    presentation: presentation,
    update: update,
    updateNonExpress: updateNonExpress,
    hasVisibleContent: hasVisibleContent
  });
});
